module.exports = __webpack_public_path__ + "static/img/img_3.47e7a9e5.jpg";